import { Directive, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { ComponentBase } from 'app/shared/component.base';
import { LabelCode } from 'app/shared/models/label-code.models';

@Directive()
export abstract class ScannedDetailsComponentBase extends ComponentBase implements OnChanges {
  @Input() labelCode: LabelCode;
  @Output() navigationInstructions = new EventEmitter<[string, number]>();
  @Output() scanFailure = new EventEmitter<void>();

  constructor() {
    super();
  }

  abstract handleCodeScanned(): void;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['labelCode']) {
      this.handleCodeScanned();
    }
  }

  handleScanFail(): void {
    this.scanFailure.emit();
  }
}
